import { render, staticRenderFns } from "./SectionHeader.component.vue?vue&type=template&id=fd84a00c&"
import script from "./SectionHeader.component.vue?vue&type=script&lang=js&"
export * from "./SectionHeader.component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports